<template>
  <div v-if="visible" class="modal-overlay" @click.self="$emit('close')">
    <div class="name-modal">
      <div class="name-modal-header">
        <h3>修改昵称</h3>
        <button class="close-btn" type="button" @click="$emit('close')">×</button>
      </div>
      <div class="name-modal-body">
        <input
          ref="nameInput"
          :value="value"
          type="text"
          placeholder="请输入昵称"
          maxlength="10"
          @input="$emit('input', $event.target.value)"
          @keyup.enter="$emit('confirm')"
        >
        <button class="confirm-name-btn" type="button" :disabled="submitting" @click="$emit('confirm')">
          {{ submitting ? '提交中...' : '确定' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NicknameModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          const input = this.$refs.nameInput
          if (input) {
            input.focus()
            input.select()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.name-modal {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 24px;
  max-width: 360px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.name-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h3 {
    color: #ffd700;
    margin: 0;
    flex: 1;
    text-align: center;
  }

  .close-btn {
    width: 32px;
    height: 32px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    cursor: pointer;
  }
}

.name-modal-body {
  display: flex;
  flex-direction: column;
  gap: 12px;

  input {
    height: 40px;
    padding: 0 12px;
    border: 1px solid rgba(255, 215, 0, 0.28);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.28);
    color: #fff;
    font-size: 14px;
    outline: none;
  }
}

.confirm-name-btn {
  height: 40px;
  border: 1px solid rgba(255, 215, 0, 0.55);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 215, 0, 0.28), rgba(255, 140, 0, 0.16));
  color: #fff7d5;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
}
</style>
